import logo_small_over_white from '../../../assets/imgs/logo_small_over_white.svg'
import './style.scss'

function HeaderLogoLanding() {
	return (
		<div className='header-logo-wrap header-logo-landing-wrap'>
			<a 
				href='/'
				aria-label='link back to home page'
			>
				<img 
					src={logo_small_over_white}
					className="header-logo"
					alt="Skivio logo" 
				/>
			</a>
		</div>
	)
}

export default HeaderLogoLanding